import React from "react";
import PropTypes from 'prop-types'
import {Typography} from "@material-ui/core";

const SurveyScoring = ({styles}) => {
    return(
        <div
            style={{
                background: styles.background,
                textAlign: styles.textAlign,
                padding: styles.padding
            }}
        >
            <Typography style={{
                padding: 5,
                fontWeight: styles.fontWeight,
                fontStyle: styles.fontStyle,
                fontSize: styles.fontSize,
                color: styles.color,
            }}>
                Score: 0
            </Typography>
        </div>
    )
};


export default SurveyScoring

SurveyScoring.propTypes = {
    surveyScoring: PropTypes.object,
    path: PropTypes.string,
    selectComponent: PropTypes.func
};